import { render, staticRenderFns } from "./new.support.page.vue?vue&type=template&id=2fccbaa8&"
import script from "./new.support.page.vue?vue&type=script&lang=js&"
export * from "./new.support.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports